import { Button, Tag } from "antd";
import styled from "styled-components";
import { AlbumItem, EAlbumItemType } from "../../types/album.type";

export const getBannerSrc = (item: AlbumItem) => {
	if (item.type === EAlbumItemType.PHOTO) {
		return item.file?.url;
	}
	return item.videoThumbnail?.url;
};

export const BannerImagePreview = styled.img`
	aspect-ratio: 1 / 1;
	width: 100%;
	object-fit: cover;
	border-radius: 10px;
`;
export const BannerItemContainer = styled.div`
	position: relative;
`;
export const BannerDeleteButton = styled(Button)`
	position: absolute;
	right: 10px;
	bottom: 10px;
`;
export const BannerSetCoverButton = styled(Button)`
	position: absolute;
	right: 60px;
	top: 10px;
`;
export const BannerCoverTag = styled(Tag)`
	position: absolute;
	font-weight: bold;
	left: 10px;
	top: 10px;
`;
export const BannerYouTubeUrl = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	word-break: break-word;
	background: #000a;
	color: #fff;
	padding: 10px;
	font-size: 11px;
	a {
		color: #fff;
	}
`;

export enum EEmployeePageType {
	PROFILE = "profile",
	HQ = "hq",
	FRANCHISE_OWNER = "franchise-owner",
	OFFICE_PERSONNEL = "staff",
	AGENT = "agent",
	AUTHOR = "author",
}

export const CLIENT_CMS = "cms-8f17bdb1-2acb-49b3-a022-b06fe228ec6e";
export const CLIENT_MOBILE = "mobile-1e71c68d-cc6b-4599-9c01-79abb9bc0cfb";
export const R123_PORTAL_ID = "43f1917e-d8e2-4eb1-b826-0cfcc3d44546";
export const LAMUDI_ID = "13c4dcad-9bfc-4861-bfd2-ab772ad12cb1";
